import React, { useContext, useState } from 'react';
import Page from '../..';
import Table, { TableHeader } from '../../../Table';
import Form from '../../../Form';
import { ValidityContext } from '../../../../provider/ValidityProvider';
import SVG from '../../../SVG';
import { getFilterColumn, setFilterColumn } from '../../../../store/utils';

const PageValidityStatus = () => {
  const {
    statuses,
    Can,
    ability,
    editStatus,
    setModal,
    onLineClickHandler,
    allValidityChecks,
    validityCheckAll,
    checkStatusIds,
    checkStatusId,
    TableControl,
    setValidity,
    deleteStatusLoadings,
    getSortField,
    setSortField,
    autocompleteValidityStatus,
    getValidity,
    searchFilter,
    setSearchFilter,
  } = useContext(ValidityContext)!.controllers.status;

  const canDeleteValidity = ability?.can('delete', 'ValidityStatus');
  const canUpdateValidity = ability?.can('update', 'ValidityStatus');
  const canUpdateOrDeleteValidity = canDeleteValidity || canUpdateValidity;
  const canUpdateAndDeleteValidity = canDeleteValidity && canUpdateValidity;

  const autocompletes = getValidity('autocompletes.status');

  const [nameLoading, setNameLoading] = useState(false);

  const autocompleteName = (e) => {
    setNameLoading(true);
    autocompleteValidityStatus('name', e.target.value)
      .then((data) => {
        setValidity(`autocompletes.status.name.data`, data);
      })
      .finally(() => {
        setNameLoading(false);
      });
  };

  const nameItems = autocompletes.name.data?.map((item) => ({
    id: item.id,
    name: `${item.value}`,
    data: item,
  }));

  const nameValue = getFilterColumn('name', searchFilter, 'LIKE');

  const headers: TableHeader[] = [
    {
      text: (
        <Form.Input.Checkbox
          checked={allValidityChecks}
          onChange={validityCheckAll}
        />
      ),
      value: 'check',
      width: 'auto',
      isFixed: true,
      tooltip: {
        translateX: 0.25,
      },
    },

    {
      text: 'Nome',
      value: 'name',
      width: '1fr',
      sort: {
        value: getSortField('name.keyword'),
        onChange: setSortField('name.keyword'),
      },
      filter: {
        label: 'Nome',
        value: nameValue,
        items: nameItems,
        onChange: (e) => {
          const value = e.target.value;
          let filter = setFilterColumn(
            'name',
            value,
            searchFilter,
            'LIKE',
            'AND',
          );
          setSearchFilter(filter);
        },
        onSelected: ({ data }) => {
          let filter = setFilterColumn(
            'name',
            data.value,
            searchFilter,
            'LIKE',
            'AND',
          );
          setSearchFilter({ ...filter, page: 1 });
        },
        handleItems: autocompleteName,
        loading: nameLoading,
      },
      tooltip: {
        translateX: 0.25,
      },
      onClear: () => {
        let filter = setFilterColumn('name', '', searchFilter);
        setSearchFilter(filter);
      },
    },
    {
      text: 'Cor',
      value: '',
      width: '120px',
      background: ({ color }) => color,
    },
    {
      text: 'Criado em',
      value: 'createdAt',
      width: '0.5fr',
      mask: ({ createdAt }) => new Date(createdAt).toLocaleString('pt-BR'),
      sort: {
        value: getSortField('createdAt'),
        onChange: setSortField('createdAt'),
      },
      tooltip: {
        translateX: 0.5,
      },
      interval: [
        {
          value: getFilterColumn('createdAt', searchFilter, 'GTE'),
          onChange: (e) => {
            const initialDate = e.target.value;
            let filter = setFilterColumn(
              'createdAt',
              initialDate,
              searchFilter,
              'GTE',
              'AND',
              'dd/MM/yyyy',
            );
            setSearchFilter(filter);
          },
          label: 'Data inicial',
        },
        {
          value: getFilterColumn('createdAt', searchFilter, 'LTE'),
          onChange: (e) => {
            const finalDate = e.target.value;
            let filter = setFilterColumn(
              'createdAt',
              finalDate,
              searchFilter,
              'LTE',
              'AND',
              'dd/MM/yyyy',
            );
            setSearchFilter(filter);
          },
          label: 'Data final',
        },
      ],
    },
    {
      text: 'Atualizado em',
      value: 'updatedAt',
      width: '0.5fr',
      mask: ({ updatedAt }) => new Date(updatedAt).toLocaleString('pt-BR'),
      sort: {
        value: getSortField('updatedAt'),
        onChange: setSortField('updatedAt'),
      },
      tooltip: {
        translateX: 0.9,
      },
      interval: [
        {
          value: getFilterColumn('updatedAt', searchFilter, 'GTE'),
          onChange: (e) => {
            const initialDate = e.target.value;
            let filter = setFilterColumn(
              'updatedAt',
              initialDate,
              searchFilter,
              'GTE',
              'AND',
              'dd/MM/yyyy',
            );
            setSearchFilter(filter);
          },
          label: 'Data inicial',
        },
        {
          value: getFilterColumn('updatedAt', searchFilter, 'LTE'),
          onChange: (e) => {
            const finalDate = e.target.value;
            let filter = setFilterColumn(
              'updatedAt',
              finalDate,
              searchFilter,
              'LTE',
              'AND',
              'dd/MM/yyyy',
            );
            setSearchFilter(filter);
          },
          label: 'Data final',
        },
      ],
    },
    ...(() =>
      canUpdateOrDeleteValidity
        ? [
            {
              text: '',
              value: 'control',
              width: canUpdateAndDeleteValidity ? '80px' : '40px',
              isFixed: true,
              fixedPosition: 'right' as any,
            },
          ]
        : [])(),
  ];

  const items = statuses.map((status, index) => ({
    $isSelected: checkStatusIds.includes(status.id),
    check: () => (
      <Form.Input.Checkbox
        checked={checkStatusIds.includes(status.id)}
        onChange={() => checkStatusId(status.id)}
      />
    ),
    ...status,
    ...(() =>
      canUpdateOrDeleteValidity
        ? {
            control: () => (
              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  columnGap: '10px',
                }}
              >
                <Can I="update" a="ValidityStatus">
                  {() => (
                    <label
                      style={{
                        display: 'flex',
                        cursor: 'pointer',
                        alignItems: 'center',
                      }}
                    >
                      {true ? (
                        <SVG.Icon.Edit
                          onClick={() => {
                            editStatus(status);
                          }}
                          width={25}
                          height={25}
                        />
                      ) : (
                        <SVG.Icon.Loader width={25} height={25} />
                      )}
                    </label>
                  )}
                </Can>
                <Can I="delete" a="ValidityStatus">
                  {() => (
                    <label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      {!deleteStatusLoadings[index] ? (
                        <SVG.Icon.Trash
                          style={{ padding: '0 2.5px' }}
                          onClick={() => {
                            setModal('single.deleteStatus', true);
                            setValidity('selected.status', status.id);
                          }}
                          width={20}
                          height={20}
                        />
                      ) : (
                        <SVG.Icon.Loader width={25} height={25} />
                      )}
                    </label>
                  )}
                </Can>
              </label>
            ),
          }
        : {})(),
  }));

  return (
    <Page className="page-banner">
      <div
        style={{
          position: 'relative',
          transition: 'min-width 500ms, max-width 500ms',
          width: '100%',
          minHeight: 'calc(100vh - 130px)',
          maxHeight: 'calc(100vh - 130px)',
          margin: '0 1rem',
          background: '#DDDDDD',
          borderRadius: '5px',
          overflow: 'hidden',
        }}
      >
        <Table
          headers={headers}
          items={items}
          size="small"
          onLineClick={onLineClickHandler}
          containerStyle={{ height: 'calc(100vh - 210px)' }}
        >
          <TableControl />
        </Table>
      </div>
    </Page>
  );
};

export default PageValidityStatus;
